import { defaultStyles } from '@visx/tooltip'

import { TMS_COLORS } from './theme'

export const CHART_COLORS_MAP: Record<MonthlyChartKeys, string> = {
  net: TMS_COLORS.blue[40],
  vat: TMS_COLORS.blue[20],
  gross: TMS_COLORS.blue[40],
}

export const TAXATION_CHART_COLORS_MAP: Record<string, string> = {
  kata: TMS_COLORS.common.shipCove,
  szja: TMS_COLORS.common.warningMessageBackground,
  szocho: TMS_COLORS.common.oasisStream,
  tbj: TMS_COLORS.common.stoicWhite,
  'kata-kulonado': TMS_COLORS.primary[50],
  ipa: TMS_COLORS.tertiary[40],
  hipa: TMS_COLORS.secondary[30],
}

export const GENERATED_TAX_FALLBACK_COLORS = [
  TMS_COLORS.common.purple,
  TMS_COLORS.common.navGreen,
  TMS_COLORS.common.pink,
  TMS_COLORS.blue[30],
  TMS_COLORS.mango[30],
]

export const CHART_TOOLTIP_STYLES = {
  ...defaultStyles,
  zIndex: 1310, // must be higher than modal's zIndex (1300) - expense transactions v2 fullscreen chart dialog
  padding: 0,
  boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)', // same shadow as Tooltip has
}

export const BAR_STYLES = {
  transitionDelay: '150ms',
  transitionDuration: '300ms',
  transitionProperty: 'fill-opacity',
}

export const LINE_STYLES = {
  transitionDelay: '150ms',
  transitionDuration: '300ms',
  transitionProperty: 'stroke-opacity',
}

export const AI_CHART_HEIGHT = 300 // in px

export enum PrintableChartVariant {
  EXPENSE = 'expense',
  INCOME = 'income',
  QUARANTINE = 'quarantine',
  PULSE_MONTHLY = 'pulse_monthly',
  PULSE_TAX_CALCULATION = 'pulse_tax_calculation',
  PULSE_VAT_LIVE = 'pulse_vat_live',
  PULSE_CHAT = 'pulse_chat',
}

export const TAXATION_TAX_CALCULATION_DISPLAY_CHART = 1
export const TAXATION_TAX_CALCULATION_DISPLAY_TABLE = 2
